import { createFileRoute } from '@tanstack/react-router';
import { ComparePage } from '~/components/pages/ComparePage';
import { pageHeadMeta } from '~/lib/seo';

export const Route = createFileRoute('/compare')({
  head: () =>
    pageHeadMeta({
      title: 'Compare nsave rates with other Alternatives',
      description: 'Compare nsave rates to other providers such as Wise, Payoneer, Xoom, OFX.',
      path: '/compare',
    }),
  component: ComparePage,
});
